var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasbubble==1),expression:"hasbubble==1"}],staticClass:"d-none d-sm-none d-lg-inline-block",class:_vm.smallbubbleclass,attrs:{"id":_vm.smallbubbleid},on:{"click":function($event){$event.preventDefault();return _vm.showhidebubble.apply(null, arguments)}}},[_vm._v("\n  ?\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }